export default __webpack_public_path__ + "static/media/iconLink.32b4fb32.svg";